<template>
  <main id="contents" class="top-padding-dark">
    <SearchTopTag
      :page-type="pageType"
      :tag-data-list="tagData"
      @click-delete-tag="deleteTagData"
    />

    <div class="wrap">
      <div class="search-body">
        <SearchTagMultiBand
          v-if="isCategoryAll"
          :page-type="pageType"
          :tag-data-list="tagData"
        />

        <SearchTagList
          v-else
          :category="category"
          :page-type="pageType"
          :tag-data-list="tagData"
        />
      </div>
    </div>
  </main>
</template>

<script>
  import _ from 'lodash'
  import { mapMutations } from 'vuex'
  import cookie from '@/common/utils/cookie'
  import { SET_CURRENT_MENU } from '@/common/resources/const'
  import { PATH_NAME_SEARCH_TAG } from '@/common/resources/router.const'
  import { titleTagNameChange } from '@/common/utils/common'
  import SearchTagMultiBand from '@/components/search/data/SearchTagMultiBand'
  import SearchTopTag from '@/components/search/view/SearchTopTag'
  import SearchTagList from '@/components/search/data/SearchTagList'

  export default {
    name: 'SearchTagResult',
    components: {
      SearchTagMultiBand,
      SearchTopTag,
      SearchTagList,
    },
    data() {
      return {
        // 검색 결과화면 타입 (broadcast: 태그검색결과-방송 movie: 태그검색결과-영화)
        pageType: '', // 'broadcast' | 'movie'
        category: 'all',
        tagData: [], // 태그 검색 데이터 | object[]
        tagLocalData: [], // localStorage 저장 tag 데이터 | string[]
        pooqzoneType: cookie.getPooqZoneType(), // todo: erase ?
      }
    },
    computed: {
      isCategoryAll() {
        return this.category === 'all'
      },
      pageTypeFromQuery() {
        return _.get(this.$route, 'pageType', null) ?? this.pageType
      },
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU]),
      replaceRouteUpdatedTag() {
        const query = this.$route?.query || {}
        this.$router.replace({
          name: PATH_NAME_SEARCH_TAG,
          query: {
            category: query.category,
            mtype: query.mtype,
            timestamp: new Date().getTime(),
          },
        })
      },
      /**
       * 로컬스토리지에 pageType 을 조회하여 tagLocalData, tagData 를 세팅한다.
       */
      setTagData() {
        const strTagList = localStorage.getItem(
          `search-${this.pageTypeFromQuery}`,
        )
        if (strTagList) {
          this.tagLocalData = strTagList.split('&')
          this.tagData = this.tagLocalData.map((tag) => {
            const tagArr = tag.split('|')
            return {
              taggroup: tagArr[0],
              text: tagArr[1],
              value: tagArr[2],
            }
          })
        }
      },
      /**
       * 로컬 스토리지에 delete tag 정보를 업데이트 시킨 후 router replace 한다.
       * @param index
       */
      deleteTagData(index) {
        this.tagData.splice(index, 1)
        this.tagLocalData.splice(index, 1)

        localStorage.removeItem(`search-${this.pageType}`)
        localStorage.setItem(
          `search-${this.pageType}`,
          this.tagLocalData.join('&'),
        )

        this.replaceRouteUpdatedTag()
      },
      initialize() {
        this.pageType = localStorage.getItem('search-type') || 'broadcast'
        this.category = _.get(this.$route, 'query.category', 'all')
      },
      resetData() {
        this.initialize()
        this.setTagData()
      },
      keyup(e) {
        if (e.target.classList.contains('search-refresh') && e.keyCode === 13) {
          document.getElementById('search-popup-close').focus()
        }
      },
    },
    watch: {
      $route() {
        this.resetData()
      },
    },
    created() {
      this[SET_CURRENT_MENU]('search')
      this.$events.$on('tag-search', () => {
        this.resetData()
      })
      this.initialize()
      this.setTagData()

      const TITLE_TAG_NAME_CHANGE = '태그 검색결과 : 웨이브'
      titleTagNameChange(TITLE_TAG_NAME_CHANGE)
    },
    mounted() {
      document.addEventListener('keyup', this.keyup)
    },
    beforeDestroy() {
      this.$events.$off('tag-search')
      document.removeEventListener('keyup', this.keyup)
    },
  }
</script>
